export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const CLEAR_AUTH = "CLEAR_AUTH";
export const VERIFIED_TOKEN = "VERIFIED_TOKEN";
export const UNAUTHENTICATED = "UNAUTHENTICATED";
export const TOGGLE_CONTACTUS = 'TOGGLE_CONTACTUS';

